import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLang } from "@/context/LangContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Footer = () => {
  const { t, fontClass } = useLang();
  const [showMusicCredit, setShowMusicCredit] = useState(false);

  useEffect(() => {
    axios.get(`${API}/ambient`).then((r) => {
      const fn = r.data?.filename || "";
      setShowMusicCredit(/kevin\s*macleod/i.test(fn));
    }).catch(() => {});
  }, []);

  return (
    <footer
      className="mt-8"
      style={{ borderTop: "1px solid var(--border)", background: "var(--bg)" }}
      data-testid="site-footer"
    >
      <div className="max-w-6xl mx-auto px-6 py-8 pb-28 text-center">
        <p className="font-ui text-sm font-semibold tracking-wide" style={{ color: "var(--text-2)" }}>
          A FutureTec Production
        </p>
        <p className="font-ui text-xs mt-1.5" style={{ color: "var(--text-muted)" }} data-testid="footer-copyright">
          © 2026 FutureTec Productions. All rights reserved.
        </p>
        {showMusicCredit && (
          <p className={`${fontClass()} text-xs mt-3`} style={{ color: "var(--text-muted)" }} data-testid="footer-music-credit">
            {t("music_credit_bg")}: “Meditation Impromptu 01” — Kevin MacLeod (
            <a href="https://incompetech.com" target="_blank" rel="noreferrer" style={{ color: "var(--accent)", textDecoration: "underline" }}>incompetech.com</a>
            ) · {t("music_credit_lic")}
          </p>
        )}
      </div>
    </footer>
  );
};
